; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Components/AddToMiniCart',['eventManager', 'moduleLoader', 'knockout'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('eventManager'), require('moduleLoader'), require('knockout')) :
    console && console.error('ProductsCollectionComponent loaded in a wrong way');
}(this/* window */, function (eventManager, moduleLoader, ko) {

    function AddToMiniCart(scope, parentSku, productSku) {
        Object.defineProperty(this, 'scope', { enumerable: !0, writable: !1, configurable: !0, value: scope });
        Object.defineProperty(this, 'parentSku', { enumerable: !0, writable: !0, configurable: !0, value: parentSku });
        Object.defineProperty(this, 'productSku', { enumerable: !0, writable: !0, configurable: !0, value: productSku });

        ko.applyBindings(this, scope);
    }

    AddToMiniCart.prototype.addProduct = function () {
        eventManager.trigger("Sage:PushProduct", this.parentSku, this.productSku);
    }

    AddToMiniCart.prototype.removeProduct = function () {
        eventManager.trigger("Sage:PopProduct", this.parentSku, this.productSku);
    }

    AddToMiniCart.init = function AddToMiniCartInit(args) {
        return args.IsEditorEditing === true
            ? null
            : new AddToMiniCart(args.scope, args.ParentSku, args.ProductSku);
    };

    return AddToMiniCart;
}));
